import { DiseaseDto } from '@/features/requests/components/NewRequest/Templates/osu/dtos/Event';
import { mapStaging } from '@/features/requests/components/NewRequest/Templates/osu/Staging/StagingForm';
import { EpisodeDto } from './dtos/Episode';
import { ComorbiditiesNames } from './OsuStore.constants';

export function mapEpisode(episode: EpisodeDto) {
  const comorbiditiesNames = Object.values(ComorbiditiesNames).filter(
    (x) => typeof 'string'
  ) as string[];
  return {
    ...episode,
    staging: mapStaging([episode.staging]),
    isSaved: true,
    riskFactors: episode.isTargetEpisode
      ? episode.riskFactors.filter(
          (riskFactor) => !comorbiditiesNames.includes(riskFactor.description)
        )
      : episode.riskFactors,
  };
}

export function mapDiseases(data: DiseaseDto[] | undefined) {
  return (
    data
      ?.sort((a, b) => a.order - b.order)
      ?.reduce(
        (diseaseAccum, diseaseCurr) => ({
          ...diseaseAccum,
          [diseaseCurr.id]: {
            ...diseaseCurr,
            isSaved: true,
            episodes: diseaseCurr.episodes.reduce(
              (epAccum, epCurr) => ({
                ...epAccum,
                [epCurr.id]: mapEpisode(epCurr),
              }),
              {}
            ),
          },
        }),
        {}
      ) ?? {}
  );
}
